export const updatePickBookingEndpoint = (shipmentUid: string) =>
  `/shipments/${shipmentUid}/update-pick-booking` as const
